var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignSignatureIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6B7280",
    d: "M13.333 8.44a.667.667 0 0 0-.846.466c-.14.514-.667 2-1.594 2.3.054-.28.147-.666.214-.886.273-1.054.473-1.807-.154-2.167a1.333 1.333 0 0 0-1.86.28c-.145.192-.268.4-.366.62a4.76 4.76 0 0 1-1.454 1.873 2.08 2.08 0 0 1-.746.22 1.647 1.647 0 0 1-.667-.333.974.974 0 0 1-.14-.187C9.247 7.24 9.44 4.286 9.4 3.4a2.393 2.393 0 0 0-.807-1.94.667.667 0 0 0-.56-.127C6.127 1.726 4.947 4 4.32 8.553l-.033.167a5.26 5.26 0 0 0-.114 1.46l-.553.486c-.244.278-.54.505-.873.667a.833.833 0 0 1 .126-.46.667.667 0 0 0-.206-.967.707.707 0 0 0-.96.18 1.8 1.8 0 0 0 .12 2.32c.226.18.51.273.8.26a2.967 2.967 0 0 0 1.92-1.027l.133-.113c.048.067.101.13.16.187a2.82 2.82 0 0 0 1.56.767c.596 0 1.18-.167 1.687-.48a5.406 5.406 0 0 0 1.646-1.96c-.28 1.046-.426 1.72-.093 2.18a.86.86 0 0 0 .627.36c1.58.18 2.9-1.067 3.526-3.334a.666.666 0 0 0-.46-.806Zm-5.42-5.62c.068.258.097.526.087.793C8 4.28 7.793 6.22 5.687 8.66c.313-2.34.98-5.107 2.226-5.84Zm6.714 4.186a.974.974 0 0 1-1.934 0 .967.967 0 0 1 1.934 0ZM13.407 13.327H2.3v1.34h11.107v-1.34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignSignatureIcon);
export default __webpack_public_path__ + "static/media/sign-signature-icon.fd62a158976c0eb402bc39fa3001f992.svg";
export { ForwardRef as ReactComponent };